import React, { type ReactNode } from 'react';

interface DetailSectionProps {
  title: ReactNode;
  children: ReactNode;
}

const DetailSection = ({ title, children }: DetailSectionProps) => {
  return (
    <div className="flex flex-col sm:flex-row w-full items-start gap-4 sm:gap-x-8">
      <div className="w-full sm:min-w-[240px] sm:max-w-[280px] sm:shrink-0">
        <span className="text-base font-bold text-secondary">{title}</span>
      </div>
      <div className="flex flex-col w-full sm:flex-1 items-start gap-2">{children}</div>
    </div>
  );
};

export default DetailSection;
